import axios from "axios";
import keycloak from "../auth/keycloak";
import authService from "../services/AuthService";

const axiosCustom = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosCustom.interceptors.request.use(
  async (config) => {
    if (keycloak.authenticated) {
      await keycloak.updateToken(30);
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosCustom.interceptors.response.use(
  (response) => response,
  async (error) => {
    const data = error.response?.data;
    if (data && data.message === "VALIDATION_FAILURE" && typeof data.result === "string" && data.result.trim()) {
      data.message = data.result;
    }

    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && keycloak.refreshToken) {
      originalRequest._retry = true;
      try {
        await keycloak.updateToken(0); 
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        
        return axiosCustom(originalRequest);
      } catch (err) {
        authService.handleAuthError(); 
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosCustom;
